import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';
import {  sessionStorage} from 'src/app/localstorage.service';


@Component({
  selector: 'app-product-detail-data',
  templateUrl: './product-detail-data.component.html',
  styleUrls: ['./product-detail-data.component.scss']
})
export class ProductDetailDataComponent implements OnInit {
  userData: any;
  userId: any;
  savingFlag:boolean = false;
  userName: any;
  from:any;
  ItemData:any=[];
  imgUrl:any='';
  otpFlag:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA)public data:any,public dialog:MatDialog, public session: sessionStorage,public serve:DatabaseService,public toast:ToastrManager)
  { { 
    this.imgUrl = this.serve.uploadUrl + 'influencer_doc/'
    this.userData = JSON.parse(localStorage.getItem('st_user'));
    this.userId=this.userData['data']['id'];
    this.from=data.from;
    if(data.from_Item){
    this.ItemData=data.itemData;
    }
    if(this.from=='item-detail' || this.data.from_Item=='purchase-item'){
      this.ItemData=data.itemData;
      }
    this.userName=this.userData['data']['name'];

  }
  }

  ngOnInit() {
  }

  changeStatus()
  {

    this.savingFlag = true;
    this.serve.post_rqst({'reason':this.data.reason,'status':this.data.status,'id':this.data.id,'uid':this.userId,'uname':this.userName},"Leaves/statusChange").subscribe((result=>{

      if(result['statusCode']==200)
      {
        this.toast.successToastr(result['statusMsg']);
        this.dialog.closeAll();
        this.savingFlag = false;
      }else{
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg']);
        this.dialog.closeAll();
      }
    }))
    this.dialog.closeAll();

  }

  goToImage(image) {
    const dialogRef = this.dialog.open(ImageModuleComponent, {
      panelClass: 'Image-modal',
      data: {
        'image': image,
        'type': 'base64'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

  }

  changePurchaseStatus(){

    this.savingFlag = true;
    this.serve.post_rqst({'reason':this.data.reason,'status':this.data.status,'id':this.data.id,'uid':this.userId,'uname':this.userName},"Leaves/statusChange").subscribe((result=>{

      if(result['statusCode']==200)
      {
        this.toast.successToastr(result['statusMsg']);
        this.dialog.closeAll();
        this.savingFlag = false;
      }else{
        this.savingFlag = false;
        this.toast.errorToastr(result['statusMsg']);
        this.dialog.closeAll();
      }
    }))
    this.dialog.closeAll();


  }

  close(){
    this.dialog.closeAll();
  }

}
